import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PageContainer from './components/PageContainer';

function App() {
  return (
    <Router>
      <Routes>

        {/* Existing routes */}
        <Route path="/" element={<PageContainer />} />
        <Route path="/:category" element={<PageContainer />} />
        <Route path="/:country/:category" element={<PageContainer />} />
        <Route path="/:country/:state/:category" element={<PageContainer />} />
        <Route path="/:country/:state/:city/:category" element={<PageContainer />} />
        
        {/* Catch all route for 404 */}
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </Router>
  );
}

export default App;
